
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderWebhookGrid extends Serenity.EntityGrid<OrderWebhookRow, any> {
        protected getColumnsKey() { return OrderWebhookColumns.columnsKey; }
        protected getDialogType() { return OrderWebhookDialog; }
        protected getIdProperty() { return OrderWebhookRow.idProperty; }
        protected getInsertPermission() { return OrderWebhookRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderWebhookRow.localTextPrefix; }
        protected getService() { return OrderWebhookService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private FranchiseeId;
        private InvoiceId;

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }
        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);
           
            buttons.push({
                title: 'Process Order',
                cssClass: 'print-button',
                onClick: () => {
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length != 1) {
                        Q.alert("Please select single Order(s) to Process order");
                        return;
                    }
                    else {
                        var param = {
                            'OrderIds': rowKeys
                        };
                        //var url = "/PrintInvoice/PrintReceipt";
                        //this.OpenWindowWithPostData(url, "", "PrintLabels", param);
                        //window.location.href = Q.resolveUrl('~/PrintInvoice/PrintReceipt?OrderIds=' + rowKeys);
                        Q.serviceRequest('/Services/Orders/OrderWebhook/ProcessOrder', rowKeys, (response) => { this.rowSelection.resetCheckedAndRefresh(), this.refresh() });
                    }
                }
            });
            

            

            return buttons;
        }
    }
}